export enum CustomerType {

  Private = 'private',
  Supplier = 'supplier'

}
